import React from 'react';
import cx from 'classnames';

import css from './style/index.module.scss';
import PositionIcon, { SLOT_TO_POSITION, POSITION_CN } from './PositionIcon';

// 真实英雄槽位识别：占位英雄对象只有 loadingImg，没有 idName。
// 一旦 idName 出现，就说明这一格已经被确认锁定，触发立绘揭示动画 + 队伍色描边。
// 新增 props（教练模式专用，但渲染时所有模式都安全）：
//   - onClick(slotIndex, hasChampion)：父级提供的点击处理（战术摇摆）
//   - swapSelected：当前格是否处于"摇摆选中"金光态
//   - swapEnabled：摇摆功能是否启用（全局开关，整局完成后才会为 true）
//   - slotIndex：0..4，用于决定底部位置图标 + 传给 onClick
const Pick = props => {
    const hasChampion = !!(props.champion && props.champion.idName);
    const position = SLOT_TO_POSITION[props.slotIndex] || null;
    const clickable = typeof props.onClick === 'function' && props.swapEnabled && hasChampion;

    const handleClick = () => {
        if (!props.onClick) return;
        props.onClick(props.slotIndex, hasChampion);
    };

    return (
        <div
            className={cx(css.Pick, {
                [css.Active]: props.isActive,
                [css.Filled]: hasChampion,
                [css.SwapSelected]: props.swapSelected,
                [css.SwapClickable]: clickable,
            })}
            onClick={clickable ? handleClick : undefined}
            role={clickable ? 'button' : undefined}
            tabIndex={clickable ? 0 : undefined}
            title={clickable ? '点击进行战术摇摆 / 互换位置' : undefined}
        >
            {props.spell1 && props.spell2 && props.config.frontend.spellsEnabled && props.champion.name && !props.isActive && <div className={cx(css.SummonerSpells)}>
                <img src={props.spell1.icon} alt="" />
                <img src={props.spell2.icon} alt="" />
            </div>}
            <div className={cx(css.PickImage, {
                [css.Active]: props.isActive
            })}>
                <img
                    key={props.champion && props.champion.loadingImg}
                    src={props.champion.loadingImg}
                    alt={hasChampion ? props.champion.name : ''}
                />
                {position && (
                    <div
                        className={cx(css.PositionIcon, {
                            [css.PositionIconLit]: hasChampion,
                        })}
                        title={POSITION_CN[position]}
                    >
                        <PositionIcon position={position} size={22} />
                    </div>
                )}
            </div>
            <div className={cx(css.PlayerName)}>
                <span>{props.displayName}</span>
            </div>
        </div>
    );
};

export default Pick;
